import React from 'react';
import { useSiteData } from 'react-static';
import PropTypes from 'prop-types';
// template components
import AdvisorConnectCard from '@nmx/template/dist/componentLibrary/modules/AdvisorConnectCard';
// images
import frPhotoWebpA from '../../../images/financialAdvisors/leo-tucker.webp';
import frPhotoWebpB from '../../../images/financialAdvisors/andrea-williams.webp';
import frPhotoWebpC from '../../../images/financialAdvisors/dan-nguyen.webp';
import frPhotoWebpD from '../../../images/financialAdvisors/john-white.webp';
import frPhotoWebpE from '../../../images/financialAdvisors/trevor-smith.webp';
import frPhotoWebpF from '../../../images/financialAdvisors/hollee-kier.webp';

export const AdvisorConnectCardSimplifiedModule = ({
  advisorImageVariant,
  backgroundVariant,
  className,
  headingText,
  id,
  linkAriaLabel,
  linkText,
  linkUrl,
  subText,
  text,
}) => {
  const { config } = useSiteData();
  let thisImageSrc;
  let thisThemeType = 'lightTheme';

  switch (advisorImageVariant) {
    case 'advisorA':
      // leo tucker
      thisImageSrc = frPhotoWebpA;
      break;
    case 'advisorB':
      // andrea williams
      thisImageSrc = frPhotoWebpB;
      break;
    case 'advisorC':
      // dan nguyen
      thisImageSrc = frPhotoWebpC;
      break;
    case 'advisorD':
      // john white
      thisImageSrc = frPhotoWebpD;
      break;
    case 'advisorE':
      // trevor smith
      thisImageSrc = frPhotoWebpE;
      break;
    case 'advisorF':
      // hollee kier
      thisImageSrc = frPhotoWebpF;
      break;
    default:
      break;
  }

  if(backgroundVariant === 'darkDefault'){
    thisThemeType = 'darkTheme';
  }

  return (
    <AdvisorConnectCard
      sectionId={`${id}-page-fr-callout`}
      className={className}
      moduleName='fr-card-fafa-module'
      moduleVariation='A'
      // configs
      config={config}
      disableLazyLoad
      removeDefaultCardForLeads
      // theming
      backgroundVariant={backgroundVariant}
      themeType={thisThemeType}
      // content
      defaultCardProps={{
        headingText,
        cta: {
          ariaLabel: linkAriaLabel,
          linkUrl,
          linkText,
          children: '',
        },
        imageOnTop: false,
        imageSrc: thisImageSrc,
        imageVariant: 'round',
        text,
        subText,
      }}
    />
  );
};

AdvisorConnectCardSimplifiedModule.propTypes = {
  /** optional advisorImageVariant */
  advisorImageVariant: PropTypes.oneOf(['advisorA', 'advisorB', 'advisorC', 'advisorD', 'advisorE', 'advisorF']),
  /** optional backgroundVariant */
  backgroundVariant: PropTypes.oneOf(['darkDefault', 'lightA', 'lightB', 'lightC']),
  /** optional className */
  className: PropTypes.string,
  /** optional headingText */
  headingText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  /** id */
  id: PropTypes.string.isRequired,
  /** optional linkAriaLabel */
  linkAriaLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  /** optional linkText */
  linkText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  /** optional linkUrl */
  linkUrl: PropTypes.string,
  /** optional subText */
  subText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  /** optional text */
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};

AdvisorConnectCardSimplifiedModule.defaultProps = {
  advisorImageVariant: 'advisorA',
  backgroundVariant: 'lightB',
  linkAriaLabel: 'Talk to a Northwestern Mutual financial advisor today.',
  linkText: (<>Let&#39;s talk</>),
  linkUrl: '/find-a-financial-advisor/',
  subText: (<>It&#39;s easy to get started&#8212;no commitment, just a better conversation.</>),
};

export default AdvisorConnectCardSimplifiedModule;
